package com.milta.core.localization.translations.es

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Importar — Foto",
    titlePdf = "Importar — PDF",
    titleSpreadsheet = "Importar — Excel / CSV",
    fileSentSuffix = "enviado hace un momento",
    fileWaitingConnectionLabel = "esperando conexión",
    analysingTitle = "Leyendo el documento…",
    analysingSubtitle = "La extracción de las entregas puede tardar unos segundos.",
    analysingSubtitlePdf = "Claude Haiku extrae las entregas — puede tardar unos segundos en un PDF escaneado.",
    stepFileSent = "Archivo enviado",
    stepExtracting = "Extracción de los campos",
    stepReview = "Revisión antes de añadir",
    successTitle = "Entrega detectada",
    successSubtitle = "Verifica la información antes de añadirla a la ruta.",
    addToRouteButton = "Añadir a la ruta",
    scanAnotherButton = "Escanear otro documento",
    partialTitle = "Casi completo",
    partialSubtitle = "No se pudo leer un campo en el documento.",
    missingFieldPlaceholder = "Por completar…",
    partialBannerText = "Parte de la información no se pudo leer. Puedes validar tal cual y completarla más tarde, o enviar un documento más nítido.",
    retryFileButton = "Enviar otro archivo",
    validateAndContinueButton = "Validar y continuar",
    attemptLabel = "Intento",
    errorTitleUnreadable = "Documento ilegible",
    errorTitleMissingFields = "Información no encontrada",
    errorTitleNetworkError = "Problema durante el análisis",
    errorTitleGeneric = "Error en el análisis",
    errorSubtitle = "No pudimos detectar una entrega en este archivo.",
    errorBannerSuffixUnreadable = "imagen demasiado oscura o texto cortado. Toma una foto bien encuadrada y bien iluminada, o envía un archivo más nítido.",
    errorBannerSuffixMissingFields = "no se encontró información utilizable. Revisa el contenido del archivo o envía otro.",
    errorBannerSuffixNetworkError = "el servicio de análisis tuvo un problema de red. Vuelve a intentarlo en unos instantes.",
    errorBannerSuffixGeneric = "se produjo un error inesperado durante el análisis. Vuelve a intentarlo o envía otro archivo.",
    retryWithNewFileButton = "Reintentar con otro archivo",
    manualEntryButton = "Introducir manualmente",
    attemptsRemainingNote = "Te queda 1 intento para este documento.",
    maxAttemptsTitle = "Aún ilegible",
    maxAttemptsSubtitle = "Este documento no se pudo leer después de 2 intentos.",
    maxAttemptsBanner = "Se alcanzó el límite de intentos para este documento. Completa la entrega manualmente, o reinicia la importación con un nuevo documento.",
    retryUnavailableButton = "Reintentar — no disponible",
    newDocumentButton = "Importar un nuevo documento",
    serviceUnavailableTitle = "Servicio temporalmente no disponible",
    serviceUnavailableSubtitle = "El análisis automático no responde en este momento.",
    serviceUnavailableBanner = "Vuelve a intentarlo en unos instantes, o completa la entrega manualmente mientras tanto.",
    offlineTitle = "Estás sin conexión",
    offlineSubtitle = "Tu archivo está listo pero aún no se ha enviado.",
    offlineBanner = "Reconéctate a Internet y luego reinicia el análisis. No se envió nada al servidor — no se contó ningún intento.",
    retryOfflineButton = "Reintentar — sin conexión",
    unsupportedFormatBanner = "Formato de archivo no compatible. Elige una foto, un PDF o un archivo Excel/CSV.",
    validationTitle = "Revisar las entregas",
    fileRejectedTitle = "Archivo no enviado",
    fileRejectedSubtitle = "Elige otro archivo para continuar.",
    bannerFileRequired = "no se seleccionó ningún archivo. Elige un archivo PDF para continuar.",
    bannerInvalidPdfFormat = "formato no compatible. Aquí solo se aceptan archivos PDF.",
    bannerFileTooLarge = "archivo demasiado grande. Elige un archivo PDF más ligero.",
    chooseAnotherFileButton = "Elegir otro archivo",
)
